import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition } from '../../models';

class UserFieldsController implements angular.IComponentController {
    mapped: string[];

    readonly fields: { [key: string]: string };
    
    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['fields'] && changesObj['fields'].currentValue) {
            this.mapped = [];
            for (const key of Object.keys(this.fields)) {
                this.mapped.push(`${key}: ${this.fields[key]}`);
            }
        }
    }
}

export const wtUserFields: ComponentDefinition = {
    componentId: 'wtUserFields',
    controller: UserFieldsController,
    template: require('./userFields.component.html'),
    controllerAs: 'vm',
    bindings: {
        fields: '<'
    }
};
